export default __webpack_public_path__ + "static/media/search.8ea56b73.svg";